module.exports = __webpack_public_path__ + "img/logo-nex-lw-white.868351a1.svg";